<template>
  <section
    class="c-day-planner__day-entry u-extra-medium-padding--bottom"
    v-bind:class="{  box : isCreateMethod }"
  >
    <template v-if="isUpdateMethod">
      <h2 class="c-day-planner__day-entry-heading">
        <template v-if="entry.project">{{ $t('project') }}</template>
        <template v-else>{{ $t('tours.name') }}</template>
      </h2>
      <div class="grid-x grid-margin-x">
        <div class="cell medium-2">
          <div class="form-group">
            <label>{{ $t('search.from') }}</label>
            <v-datepicker
              class="form-control form-control--small form-control--date"
              :placeholder="$t('search.from')"
              :format="$t('search.from') + ' ' + $helpers.dateFormat"
              :clearButton="true"
              :monday-first="true"
              :disabled-dates="$helpers.disabledDates"
              :language="de"
              v-model="entry.startdate"
            />
          </div>
        </div>

        <div class="cell medium-2">
          <div class="form-group">
            <label>{{ $t('search.till') }}</label>
            <v-datepicker
              class="form-control form-control--small form-control--date"
              :placeholder="$t('search.till')"
              :format="$t('search.till') + ' ' + $helpers.dateFormat"
              :clearButton="true"
              :monday-first="true"
              :disabled-dates="{ days: [6, 0], to : new Date(entry.startdate) }"
              :language="de"
              v-model="entry.enddate"
            />
          </div>
        </div>

        <div class="cell medium-2">
          <div class="form-group">
            <label for="form-field-kolonne">{{ $t('tours.kolonne') }}</label>
            <v-select-kolonne
              id="form-field-kolonne"
              name="kolonne"
              :placeholder="$t('select')"
              v-model="entry.kolonne"
            />
          </div>
        </div>

        <div class="cell medium-6">
          <div class="form-group">
            <label>{{ $t('form.upload.comment') }}</label>
            <textarea name="comment" v-model="entry.comment" />
          </div>
        </div>
      </div>
      
      <div class="grid-x grid-margin-x">
      
        <div class="cell medium-2">
          <div class="form-group" v-if="entry.project_id">
            <label class="text-center">{{ $t("weeks.project.print_uploads") }}</label>
            <input
              type="checkbox"
              :value="true"
              name="print_attachments"
              v-model="entry.print_attachments"
            />
          </div>
        </div>
        <div class="cell medium-1">
            <div class="form-group">
                <label class="text-center">{{ $t("weeks.project.milling") }}</label>
                <input
                        type="checkbox"
                        name="milling"
                        :value="true"
                        v-model="entry.milling"
                        @change="updateComment(entry.milling)"
                />
            </div>
        </div>
        <div class="cell medium-2">
            <div class="form-group">
                <label class="text-center">{{ $t("weeks.project.is_date_fixed") }}</label>
                <input
                        type="checkbox"
                        name="is_date_fixed"
                        :value="true"
                        v-model="entry.is_date_fixed"
                />
            </div>
        </div>
      </div>
    </template>
    <template v-if="isCreateMethod">
      <div class="grid-x grid-margin-x">
        <div class="cell medium-2">
          <div class="form-group">
            <label>{{ $t('search.from') }}</label>
            <v-datepicker
              class="form-control form-control--small form-control--date"
              :placeholder="$t('search.from')"
              :format="$t('search.from') + ' ' + $helpers.dateFormat"
              :clearButton="true"
              :monday-first="true"
              v-model="startdate"
              :disabled-dates="$helpers.disabledDates"
              :language="de"
            />
          </div>
        </div>

        <div class="cell medium-2">
          <div class="form-group">
            <label>{{ $t('search.till') }}</label>
            <v-datepicker
              class="form-control form-control--small form-control--date"
              :placeholder="$t('search.till')"
              :format="$t('search.till') + ' ' + $helpers.dateFormat"
              :clearButton="true"
              :monday-first="true"
              v-model="enddate"
              :disabled-dates="{ days: [6, 0], to : new Date(startdate) }"
              :language="de"
            />
          </div>
        </div>

        <div class="cell medium-2">
          <div class="form-group">
            <label for="form-field-kolonne">{{ $t('tours.kolonne') }}</label>
            <v-select-kolonne
              id="form-field-kolonne"
              name="kolonne"
              :placeholder="$t('select')"
              v-model="kolonne"
            />
          </div>
        </div>

        <div class="cell medium-3">
          <div class="form-group">
            <label>{{ $t('form.upload.comment') }}</label>
            <textarea name="comment" v-model="comment" />
          </div>
        </div>

        <div class="cell medium-2">
          <div class="form-group">
            <label>{{ $t("weeks.project.print_uploads") }}</label>
            <input
              type="checkbox"
              :value="true"
              name="print_attachments"
              v-model="print_attachments"
            />
          </div>
        </div>
        <div class="cell medium-1">
            <div class="form-group">
                <label>{{ $t("weeks.project.milling") }}</label>
                <input
                  type="checkbox"
                  name="milling"
                  :value="false"
                  v-model="milling"
                  @change="updateComment(milling)"
                />
            </div>
        </div>
        <div class="cell medium-1">
            <div class="form-group">
                <label>{{ $t("weeks.project.is_date_fixed") }}</label>
                <input
                  type="checkbox"
                  name="is_date_fixed"
                  :value="false"
                  v-model="is_date_fixed"
                />
            </div>
        </div>
      </div>
      <div class="c-day-planner__search">
        <form
          action
          method="POST"
          class="filter filter--search"
          novalidation
          @submit="searchProject"
        >
          <div class="grid-x grid-margin-x">
            <div class="cell small-12 medium-4">
              <div class="form-group form-group--search">
                <input
                  type="text"
                  class="form-control form-control--small form-control--search"
                  :placeholder="$t('search.project_number')"
                  v-model="projectsTableFilter.search"
                />
                <button
                  role="button"
                  type="submit"
                  class="button"
                  :title="$t('search')"
                >{{ $t('search') }}</button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </template>

    <div class="c-day-planner__table" v-if="isCreateMethod || entry.project !== null">
      <v-table
        :isLoading="projectTableLoading"
        :columns="projectTableColumns"
        :items="projectTableItem"
        :showHeaderRow="true"
        :showShowAll="false"
        :useDetailRow="false"
      >
        <template slot="project_number" slot-scope="{ row }">
          <router-link
            :to="{ name : 'customers-update-customer-project', params : { customer : row.customer_id, project : row.id } }"
            class="table__subtil-link"
            :title="$t('update')"
          >{{ row.project_number }}</router-link>
          <!-- Output for warning if project belongs to other weekplan entries -->
          <template v-if="isCreateMethod">
            <div v-if="weekplans.length >= 1" class="callout warning text-center">
              <p class="u-extra-small-margin--bottom">
                <strong>{{ $t('weeks.message.entryexits.title') }}:</strong>
              </p>
              <div v-for="(weekplan, index) in weekplans" :key="index">
                <section>{{ $t('date.on') }}: {{weekplan.startdate | moment("DD.MM.YYYY") }}, {{ $t('kolonne.title') }}: {{ weekplan.kolonne }}</section>
              </div>
            </div>
          </template>
          <template v-else>
            <div v-if="weekplans.length >= 2" class="callout warning text-center">
              <p class="u-extra-small-margin--bottom">
                <strong>{{ $t('weeks.message.entryexits.title') }}:</strong>
              </p>
              <div v-for="(weekplan, index) in weekplans" :key="index">
                <section
                  v-if="weekplan.id != entry.id"
                >{{ $t('date.on') }}: {{weekplan.startdate | moment("DD.MM.YYYY") }}, {{ $t('kolonne.title') }}: {{ weekplan.kolonne }}</section>
              </div>
            </div>
          </template>
        </template>

        <template slot="company_name" slot-scope="{ row }">
          <div class="u-extra-small-margin--bottom">{{ row.customer.company_name }}</div>
          <div v-if="row.account.profile_id != ''" class="u-extra-small-margin--bottom">
            <strong>{{ $t('pms') }}</strong>
            <br />
            {{ row.account.profile.firstname }} {{ row.account.profile.lastname }}
            <br />
            <div
              v-if="row.account.profile.communication.phone"
            >Tel.: {{ row.account.profile.communication.phone }}</div>
            <div
              v-if="row.account.profile.communication.mobile"
            >Mobil: {{ row.account.profile.communication.mobile }}</div>
          </div>
          <div v-if="row.site_contact_info != ''" class="u-extra-small-margin--bottom">
            <strong>{{ $t('customers.contact_person') }}</strong>
            <br />
            {{ row.site_contact_info }}
          </div>
          <div class="u-extra-small-margin--bottom">
              <strong>Limit</strong>
              <template v-if="row.location.risk">
                <template v-if="row.location.risk.decided_budget">
                    <div>{{ $t('location.risk.limit') }}: {{$helpers.formateCurrency(row.location.risk.decided_budget)}}</div>
                </template>
                <template v-else>
                    <div class="u-color--alert">
                      <strong>{{ $t('location.risk.decided_budget.not_exist') }}</strong>
                    </div>
                </template>
                <template v-if="row.location.risk.valid_from">
                    <div>{{ $t('location.risk.valid_from') }}: {{row.location.risk.valid_from | moment('DD.MM.YYYY')}}</div>
                </template>
                <template v-if="row.location.risk.valid_until">
                    <div>{{ $t('location.risk.valid_until') }}: {{row.location.risk.valid_until | moment('DD.MM.YYYY')}}</div>
                </template>
                <div v-if="!row.location.risk.is_valid" class="u-color--alert">
                    <strong>{{$t('location.risk.not_valid')}}</strong>
                </div>
                </template>
              <template v-else>
                  <div class="u-color--alert"><strong>{{$t('location.risk.no_risk_number')}}</strong></div>
              </template>
          </div>
        </template>

        <template slot="address" slot-scope="{ row }">
          <strong>{{ row.address.zipcode }} {{ row.address.city }}</strong>
          <br />
          {{ row.address.street }} {{ row.address.housenumber }}
        </template>

        <template slot="layers" slot-scope="{ row }">
          <template v-for="layer in row.layers">
            <p class="u-extra-small-margin--bottom" v-if="layer.open_qm !== 0">
              <label class="c-day-planner__layer-label">
                <input
                  type="checkbox"
                  class="c-day-planner__layer-checkbox"
                  :value="layer.id"
                  v-model="scheduleLayers"
                />
                <span>{{ layer.subtype }}</span>
              </label>
            </p>
            <p
              :title="$t('status.finished')"
              class="u-extra-small-margin--bottom u-color--success"
              v-else
            >{{ layer.subtype }}</p>
          </template>
        </template>
        <template slot="thickness" slot-scope="{ row }">
          <template v-for="layer in row.layers">
            <p class="u-extra-small-margin--bottom">
              <strong>{{ layer.thickness }}</strong>
            </p>
          </template>
        </template>
        <template slot="openqm" slot-scope="{ row }">
          <template v-for="layer in row.layers">
            <p class="u-extra-small-margin--bottom">
              <strong>{{ layer.open_qm }}</strong>
              /
              <span class="u-text-small">{{ layer.qm }}</span>
            </p>
          </template>
        </template>

        <template slot="tons" slot-scope="{ row }">
          <template v-for="layer in row.layers">
            <p class="u-extra-small-margin--bottom">
              <span
                class="c-day-planner__tons-label"
              >{{ layer.open_qm | calcTons(layer.thickness) }}</span>
            </p>
          </template>
        </template>

        <template slot="tok" slot-scope="{ row }">
          <span v-if="row.layer_tok">{{ $t('yes') }}</span>
          <span class="u-error" v-else>{{ $t('no') }}</span>
        </template>

        <template slot="deadline" slot-scope="{ row }">
          <span v-if="row.earliest_start">{{ $helpers.formatEarliestStartLabel(row.earliest_start) }}</span>
          <span v-if="row.earliest_start_comment"> {{ row.earliest_start_comment }}</span>
          <span v-if="!row.earliest_start_comment && row.requested_deadline"> {{ row.requested_deadline }}</span>
        </template>

        <template slot="uploads" slot-scope="{ row }">
          <template v-if="row.uploads.length > 0">
            <router-link
              :to="{ name : 'customers-view-customer-project-media', params : { customer : row.customer_id, project : row.id } }"
              class="button button--action button--action--files button--small"
              :title="$t('media')"
            >{{ $t('media') }}</router-link>
          </template>
          <template v-else>{{ $t('no') }}</template>
        </template>
      </v-table>
    </div>

    <template v-if="isUpdateMethod">
      <div v-if="entry.tour !== null">
        <p class="u-no-margin u-extra-small-margin--bottom">
          <span class="h5">{{ $t('tours.tournumber') }}:</span>
          <strong>{{ entry.tour.tour_number }}</strong>
        </p>
      </div>
    </template>

    <div v-if="currentProject.site_comments">
      <p>
        <strong>{{ $t('form.comments.comment') }}</strong>
        <br />
        {{ currentProject.site_comments }}
      </p>
    </div>

    <template v-if="isUpdateMethod">
      <div
        class="c-day-planner__mixing-plants grid-x grid-margin-x u-extra-small-margin--bottom"
        v-if="entry.project"
      >
        <div class="cell small-12">
          <p class="u-extra-small-margin--bottom">
            <strong>{{ $t('tours.mixingplants') }}</strong>
          </p>
        </div>
        <div class="cell small-auto medium-3">
          <a
            :title="$t('insert')"
            class="button secondary small"
            @click.prevent="openMixingPlantSearch(entry.project.address.zipcode, '0')"
          >{{ $t('tours.mixingplants') }} {{ $t('insert') }}</a>
        </div>
        <div class="cell small-auto medium-9">
          <div
            class="callout warning text-center callout--over-table"
            v-if="mixingPlantResultsTableItemsSelected.length == 0"
          >{{ $t('weeks.warning.nomixingplant') }}</div>
          <v-table
            :isLoading="mixingPlantTableLoading"
            :columns="mixingPlantTableColumns"
            :items="mixingPlantTableItems"
            :showHeaderRow="false"
            :showShowAll="false"
            :useDetailRow="false"
            :reloadTable="mixingPlantReloadTable"
          >
            <template slot="company_name" slot-scope="{ row }">
              <p class="u-extra-small-margin--bottom">
                 <span class="c-ranking" :class="rankingClass(row.ranking)"></span>
                  {{ row.name }}
              </p>
              <p class="u-no-margin" v-if="row.phone">Tel.: {{ row.phone }}</p>
            </template>
            <template slot="address" slot-scope="{ row }">
              <p class="u-extra-small-margin--bottom">
                <strong>{{ row.address.zipcode }} {{ row.address.city }}</strong>
              </p>
              <p>{{ row.address.street }} {{ row.address.housenumber }}</p>
            </template>
            <template slot="comment" slot-scope="{row}">
              <textarea v-model="row.comment"></textarea>
            </template>
            <template slot="delete" slot-scope="{row}">
              <label>
                <input
                  type="checkbox"
                  v-model="mixingPlantResultsTableItemsSelected"
                  name="mixing_plants_selected[]"
                  :value="row.id"
                />
                <i></i>
              </label>
            </template>
          </v-table>
        </div>
      </div>
    </template>
    <v-mixing-plant-search-modal
      :isVisible="mixingPlantSearchModal.isVisible"
      v-model="mixingPlantSearchModal.isVisible"
      :zipcode="mixingplantZipcode"
      :rowUid="mixingplantRowUid"
      @addMixingplantsToRoute="addMixingplantsFromModal"
    ></v-mixing-plant-search-modal>
    <template v-if="isUpdateMethod">
      <div class="grid-x grid-margin-x">
        <div class="cell small-auto medium-9">
          <button
            role="button"
            @click.prevent="updateEntry"
            class="button button--action--save"
            :title="$t('form.submit.save')"
          >{{ $t('form.submit.save') }}</button>
        </div>

        <div class="cell small-auto medium-3 text-right">
          <div v-if="entry.tour !== null">
            <router-link
              :to="{ name : 'update-tour', params: {tour: entry.tour_id} }"
              :title="$t('update')"
              class="button gray"
            >{{ $t('tours.update.title') }}</router-link>
          </div>
          <div v-if="entry.project">
            <button
              role="button"
              @click.prevent="triggerDeleteModal"
              class="button gray"
              :title="$t('delete')"
            >{{ $t('delete') }}</button>
          </div>
        </div>
      </div>
      <v-dialog
        :isVisible="isVisible"
        :messageType="messageType"
        :content="dialogContent"
        v-model="isVisible"
        @deleteEntry="handleDelete"
      ></v-dialog>
    </template>
    <template v-if="isCreateMethod">
      <div class="grid-x grid-margin-x">
        <div class="cell auto">
          <template v-if="currentProject.length !== 0">
            <button
              role="button"
              @click.prevent="createEntry"
              type="submit"
              class="button"
              :title="$t('form.submit.insert')"
            >{{ $t('form.submit.insert') }}</button>
          </template>

          <button
            role="button"
            @click.prevent="cancelEntry"
            class="button gray"
            :title="$t('cancel')"
          >{{ $t('cancel') }}</button>
        </div>
      </div>
      <v-dialog
        :isVisible="isVisible"
        :messageType="messageType"
        :content="dialogContent"
        v-model="isVisible"
      ></v-dialog>
    </template>
  </section>
</template>
<script>
import SelectKolonne from "./../../partials/Forms/SelectKolonne";
import Datepicker from "vuejs-datepicker";
import { de } from "vuejs-datepicker/dist/locale";
import Table from "./../../partials/Foundation/Table";
import Dialog from "./../../partials/CommunicationDialog";
import MixingPlantSearchModal from "./../../partials/MixingPlantSearchModal";

export default {
  name: "WeekDayCrud",
  data() {
    return {
      de: de,
      isLoaded: false,
      saveOrderFromParent: this.parentToSave,
      mixingPlantSearchModal: {
        isVisible: false,
      },
      mixingplantZipcode: "",
      mixingplantRowUid: "",
      scheduleLayers: [],
      dialogContent: "",
      messageType: "default",
      isVisible: false,
      deleteEntryItem: false,
      projectTableLoading: true,
      projectTableItem: [],
      currentProject: [],
      mixingPlantReloadTable: true,
      mixingPlantTableLoading: false,
      mixingPlantResultsTableItemsSelected: [],
      mixingPlantTableItems: [],
      mixingPlantTableColumns: [
        { key: "company_name" },
        { key: "address" },
        { key: "comment" },
        { key: "delete" },
      ],
      projectTableColumns: [
        { key: "project_number", label: this.$t("weeks.project.number") },
        { key: "company_name", label: this.$t("weeks.project.company_name") },
        { key: "address", label: this.$t("weeks.project.address") },
        {
          key: "layers",
          label: this.$t("weeks.project.layers"),
          width: "190px",
        },
        { key: "thickness", label: this.$t("weeks.project.thickness") },

        {
          key: "openqm",
          label: this.$t("weeks.project.openqm"),
          width: "105px",
        },
        {
          key: "tons",
          label: this.$t("tons"),
        },
        { key: "tok", label: this.$t("weeks.project.tok") },
        { key: "deadline", label: this.$t("weeks.project.deadline") },
        { key: "uploads", label: this.$t("weeks.project.uploads") },
      ],
      projectsTableFilter: {
        search: this.$route.query.search || "",
      },
      machine: "",
      comment: "",
      layers: "",
      print_attachments: true,
      milling: false,
      is_date_fixed: false,
      startdate: this.$route.params.date || "",
      enddate: this.$route.params.date || "",
      kolonne: this.$route.params.kolonne || "",
      project_id: null,
      weekplans: [],
    };
  },
  components: {
    vDatepicker: Datepicker,
    vSelectKolonne: SelectKolonne,
    vTable: Table,
    VDialog: Dialog,
    vMixingPlantSearchModal: MixingPlantSearchModal,
  },
  props: {
    method: {
      type: String,
      default: "",
    },
    entry: {
      type: Object,
      default: () => {},
    },
    parentToSave: {
      type: Boolean,
      default: false,
    },
  },
  mounted: function () {
    if (this.method === "update" && this.entry.project !== null) {
      this.getProject();
      this.getMixingplants();
    } else if (this.method === "create") {
      this.projectTableLoading = false;
    }
  },
  beforeUpdate: function () {
    this.isLoaded = true; // This is needed for our fieldchanged watching. We only want to watch after it has been mounted and when it has been updated
  },

  computed: {
    isCreateMethod: function () {
      return this.method === "create";
    },
    isUpdateMethod: function () {
      return this.method === "update";
    },
  },
  filters: {
    calcTons: function (a, b) {
      let result = Math.round(parseInt(a) * parseInt(b) * 0.024);
      return result;
    },
  },
  watch: {
    parentToSave: {
      handler(val) {
        this.saveOrderFromParent = val;
        if (this.saveOrderFromParent) {
          this.updateEntry();
        }
      },
    },
    entry: {
      handler() {
        if (this.isLoaded) {
          if (!this.$store.getters.getFormChangeState) {
            this.$store.dispatch("setFormChanged");
          }
        }
      },
      deep: true,
    },
    mixingPlantResultsTableItemsSelected: {
      handler(val) {
        this.entry.mixingplants = val;
      },
    },
  },

  methods: {
    updateComment: function (value) {
        const millingComment = this.$t('weeks.project.milling.comment') + '\n\n';
        const reg = new RegExp('^' + millingComment.replace('+', '\\+'), 'gm');
        let comment = this.isCreateMethod ? this.comment : this.entry.comment;
        let newComment = value ? millingComment + comment : comment.replace(reg, '');
        if (this.isCreateMethod) {
            this.comment = newComment;
        } else {
            this.entry.comment = newComment;
        }
    },
    rankingClass: function (ranking) {
        if (ranking == '') {
            ranking = 'none';
        }
        return 'c-ranking--' + ranking;
    },
    
    setScheduledLayersForApi: function () {
       window.app.$helpers.logger("Scheduling layers...");
      let matches = [];
      this.scheduleLayers.forEach((row) => {
        let match = this.currentProject.layers.find((el) => {
          if (el.id === row) {
            return true;
          }
        });

        if (match != undefined) {
          matches.push({
            id: match.id,
            subtype: match.subtype,
          });
        }
      });
      return matches;
    },

    triggerDeleteModal: function () {
      this.isVisible = true;
      this.messageType = "delete";
      this.dialogContent = this.$t("weeks.message.delete");
    },

    handleDelete: function (value) {
      this.deleteEntryItem = value;

      if (this.deleteEntryItem) {
        this.deleteEntry();
      }
    },

    cancelEntry: function () {
      let returnDate = "";
      if (this.method === "update") {
        returnDate = this.entry.startdate;
      } else {
        returnDate = this.$moment(this.startdate).format();
      }
      this.$router.push({
        name: "weeks",
        params: {
          startdate: returnDate,
        },
      });
    },

    createEntry: function () {
      let body = {
        startdate: this.$moment(this.startdate).format(),
        enddate: this.$moment(this.enddate).format(),
        kolonne: this.kolonne,
        machine: this.machine,
        comment: this.comment,
        project_id: this.project_id,
        layers: this.setScheduledLayersForApi(),
        print_attachments: this.print_attachments,
        milling: this.milling,
        is_date_fixed: this.is_date_fixed,
      };

      let promise = this.$api.clearParams().post("weekplan", body);

      promise
        .then(
          ((response) => {
            if (this.$route.meta.method == "update") {
              /**
               * What happens in case of "update" state:
               * Emitting state to parent component
               * Parent list component handles all sorting logic including creation of weekday object
               * Send the entry id to the parent component
               */

              this.$emit("refresh", response.data.data.id, "create");
            } else if (this.$route.meta.method == "create") {
              /**
               * What happens in case of "create" state:
               * We have no other entries for this day, so we just refresh to an "update" state
               */

              this.$router.push({
                name: "update-day",
                params: {
                  date: this.$moment(this.startdate).format("YYYY-MM-DD"),
                  kolonne: this.kolonne,
                },
              });
            }
          }).bind(this)
        )
        .catch(
          ((error) => {
            this.isVisible = true;
            this.messageType = "error";
            this.dialogContent = error.response.data.message;
            window.app.$helpers.logger(error.response.data.message);
          }).bind(this)
        );
    },

    updateEntry: function () {
      window.app.$helpers.logger("Updating weekplan entry...", this.entry.id);
      this.entry.layers = this.setScheduledLayersForApi();

      let mixingplants = [];
      this.mixingPlantResultsTableItemsSelected.forEach((item) => {
        let key = this.mixingPlantTableItems.findIndex((row) => row.id == item);
        if (
          key !== undefined &&
          this.mixingPlantTableItems[key] !== undefined
        ) {
          mixingplants.push(this.mixingPlantTableItems[key]);
        }
      });
      this.entry.mixingplants = mixingplants;

      let promise = this.$api
        .clearParams()
        .put("weekplan/" + this.entry.id + "/", this.entry);

      promise
        .then(
          ((response) => {
            window.app.$helpers.logger(
              "Updating weekplan entry was successful, refreshing...",
              this.entry.id
            );
            /**
             * Emitting state to parent component
             * Parent list component handles all sorting logic including creation of weekday object
             * Send the entry id to the parent component
             */
            this.$emit("refresh", this.entry.id, "update");
          }).bind(this)
        )
        .catch(
          ((error) => {
            this.isVisible = true;
            this.messageType = "error";
            this.dialogContent = this.$t("weeks.error.save");
            window.app.$helpers.logger(error);
          }).bind(this)
        )
        .finally(() => {
          this.saveOrderFromParent = false;
        });
    },

    deleteEntry: function () {
      let promise = this.$api
        .clearParams()
        .delete("weekplan/" + this.entry.id + "/");
      promise
        .then(
          ((response) => {
            /**
             * Emitting state to parent component
             * Parent list component handles all sorting logic including creation of weekday object
             * Send the entry id to the parent component
             */
            this.$store.dispatch("setFormReset");
            this.$emit("refresh", this.entry.id, "delete");
          }).bind(this)
        )
        .catch(
          ((error) => {
            this.isVisible = true;
            this.messageType = "error";
            this.dialogContent = this.$t("weeks.error.delete");
            window.app.$helpers.logger(error);
          }).bind(this)
        );
    },

    getProject: function () {
      this.projectTableItem = [];

      let promise = this.$api
        .clearParams()
        .get("projects/" + this.entry.project.id + "/get");
      promise
        .then(
          ((response) => {
            this.currentProject = response.data.data;
            this.project_id = this.currentProject.id;
            this.projectTableItem.push(this.currentProject);
            // check if this project belongs to other weekplan entries
            this.getWeekplansByProjectId();

            this.entry.layers.forEach((item) => {
              this.scheduleLayers.push(item.id);
            });
             
          }).bind(this)
        )
        .catch(
          ((error) => {
            window.app.$helpers.logger(error);
            this.projectTableItem = [];
          }).bind(this)
        )
        .finally(
          (() => {
            this.projectTableLoading = false;
          }).bind(this)
        );
    },

    searchProject: function (event) {
      event.preventDefault();
      this.projectTableLoading = true;
      this.projectTableItem = [];
      let promise = this.$api
        .clearParams()
        .addParam("search", this.projectsTableFilter.search)
        .get("projects");
      promise
        .then(
          ((response) => {
            if (
              response.data.data[0].status == "open" ||
              response.data.data[0].status == "busy"
            ) {
              this.currentProject = response.data.data;
              this.currentProject = this.currentProject[0];

              this.project_id = this.currentProject.id;
              this.projectTableItem.push(this.currentProject);

              // when we find a project, set all layers to true as default
              this.setAllLayers();
              // check if this project belongs to other weekplan entries
              this.getWeekplansByProjectId();
            }
          }).bind(this)
        )
        .catch(
          ((error) => {
            window.app.$helpers.logger(error);
            this.projectTableItem = [];
          }).bind(this)
        )
        .finally(
          (() => {
            this.projectTableLoading = false;
          }).bind(this)
        );
    },

    setAllLayers: function () {
      this.scheduleLayers = [];
      this.projectTableItem.forEach((item) => {
        item.layers.forEach((layer) => {
          this.scheduleLayers.push(layer.id);
        });
      });
    },

    openMixingPlantSearch: function (zipcode, rowUid) {
      this.mixingplantZipcode = zipcode;
      this.mixingplantRowUid = rowUid;
      this.mixingPlantSearchModal.isVisible = true;
    },

    addMixingplantsFromModal: function (mixingplants) {
      this.mixingPlantReloadTable = true;
      mixingplants.forEach((plant) => {
        if (!this.mixingPlantTableItems.find((item) => item.id === plant.id)) {
          this.mixingPlantTableItems.push(plant);
          this.mixingPlantResultsTableItemsSelected.push(plant.id);
        }
      });
      this.mixingPlantTableLoading = false;
      this.resetMixingPlantsReloadTable();
    },

    getMixingplants: function () {
      this.mixingPlantReloadTable = true;
      this.entry.mixingplants.forEach((item) => {
        this.mixingPlantTableItems.push(item);
        this.mixingPlantResultsTableItemsSelected.push(item.id);
      });
      this.resetMixingPlantsReloadTable();
    },

    resetMixingPlantsReloadTable: function () {
      this.$nextTick(function () {
        // $nextTick callback function after vue updates DOM.
        this.mixingPlantReloadTable = false;
      });
    },

    getWeekplansByProjectId: function () {
      let promise = this.$api
        .clearParams()
        .addParam("project_id", this.project_id)
        .addParam("sortdir", "asc")
        .get("weekplan");

      return promise
        .then(
          function (response) {
            this.weekplans = response.data.data;
          }.bind(this)
        )
        .catch(
          function (error) {
            window.app.$helpers.logger(error.response.data.message);
          }.bind(this)
        );
    },
  },
};
</script>